module.exports = __webpack_public_path__ + "assets/img/signet_gross.64778943.jpeg";